export const checkIsUnionPay = (value: string) => !!value?.match(/^81|^62/);
